package ru.it_mozaika.sender.js.application.components.triggers

import io.ktor.client.call.*
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import react.dom.onChange
import react.router.useNavigate
import ru.it_mozaika.sender.common.models.Category
import ru.it_mozaika.sender.common.models.TriggerStatus
import ru.it_mozaika.sender.common.models.TriggerTitle
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import ru.it_mozaika.sender.js.application.context.useBackdrop
import web.cssom.AlignItems
import web.cssom.px
import web.html.InputType

external interface TriggerDialogProps: Props {
    var isOpen: Boolean
    var selected: TriggerTitle?
    var onClose: () -> Unit


}

val triggerDialog = FC<TriggerDialogProps> { props ->

    val (categories, setCategories) = useState<List<Category>>(listOf())
    val (name, setName) = useState<String>()
    val (category, setCategory) = useState<Category>()
    val navigate = useNavigate()
    val backdrop = useBackdrop()
    val storeContext = useContext(StoreContext)
    val requestResult = useContext(RequestResultContext)

    useEffect(props.selected, categories) {
        if(props.selected == null) {
            setName(null)
            setCategory(null)
        } else {
            setName(props.selected?.name)
            setCategory(categories.find{it.id == props.selected!!.category })
            storeContext.setStore(props.selected!!.store)
        }
    }

    useEffectOnce {
        Http.get("/triggers/categories") { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            val list = response.body<List<Category>>()
            setCategories(list)
        }
    }

    Dialog {
        this.open = props.isOpen
        DialogTitle {
            if (props.selected == null) {
                +"Создание нового триггера"
            } else {
               +  "Редактирование триггера"
            }
        }
        DialogContent {
            Stack {
                sx {
                    paddingTop = 5.px
                }
                direction = responsive(StackDirection.column)
                this.spacing = responsive(2)
                TextField {
                    value = name ?: ""
                    sx {
                        minWidth = 200.px
                        height = 50.px
                    }
                    id = "trigger-name-field"
                    label = ReactNode("Введите наименование:")
                    required = true
                    type = InputType.text
                    fullWidth = true
                    variant = FormControlVariant.outlined
                    error = name.isNullOrBlank()
                    this.onChange = { event ->
                        val newValue = (event.target as? web.html.HTMLInputElement)?.value.orEmpty()
                        setName(newValue)
                    }
                }
                StoresSelect()
                FormControl {
                    sx { minWidth = 200.px }

                    InputLabel {
                        id = "categories-select-label"
                        +"Выберите категорию"
                    }
                    Select {
                        labelId = "categories-select-label"
                        id = "categories-select"
                        error = category == null
                        value = category?.id ?: ""
                        label = ReactNode("Выберите категорию:")
                        onChange = { e, _ ->
                            val value = categories.find{it.id == e.target.value}
                            setCategory(value)
                        }
                            categories.forEach {
                                MenuItem {
                                    value = it.id
                                    +it.name
                                }
                            }
                    }
                }
            }
        }
        DialogActions {
            Stack {
                sx{
                    alignItems = AlignItems.flexEnd
                }
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    color = ButtonColor.secondary
                    disabled = name.isNullOrBlank() || storeContext.currentStore == null
                    if (props.selected == null) {
                        + "Создать"
                    } else {
                        + "Сохранить изменения"
                    }
                    variant = ButtonVariant.outlined
                    this.onClick = {
                        backdrop.show()
                        if (!name.isNullOrBlank() && storeContext.currentStoreId != null) {
                            if (props.selected == null) {
                                Http.put(
                                    "/triggers",
                                    TriggerTitle(
                                        "",
                                        name,
                                        true,
                                        storeContext.currentStoreId!!,
                                        category?.id ?: "",
                                        TriggerStatus.Template
                                    )
                                ) { response ->
                                    requestResult.handleRequestRespond(response)
                                    val id = response.headers["ID"].orEmpty()
                                    navigate("/editor/trigger/$id")
                                    props.onClose()
                                    backdrop.hide()
                                }
                            } else {
                                if (props.selected != null) {
                                    Http.post(
                                        "/triggers/${props.selected?.id}/title",
                                        props.selected!!.copy(
                                            name = name,
                                            store = storeContext.currentStoreId!!,
                                            category = category?.id ?: ""
                                        )
                                    ) { response ->
                                        requestResult.handleRequestRespond(response)
                                        props.onClose()
                                        backdrop.hide()
                                    }
                                }
                            }

                        }
                    }
                }
                Button {
                    +  "Отмена"
                    color = ButtonColor.error
                    onClick = {
                        props.onClose()
                    }
                    variant = ButtonVariant.outlined
                }
            }
        }
    }
}